<template>
  <div
    v-if="Object.keys(surfaces).length"
    id="surfaces-container"
  >
    <LazyHH4 class="mt-5 mb-4">
      Surfaces
    </LazyHH4>

    <div class="container">
      <div
        v-if="show"
        class="row"
      >
        <div
          v-for="surface in surfaces"
          :key="surface.type"
          class="col-12 surface"
        >
          <div class="row">
            <div class="col-7 label">
              {{ surface.number }}
              {{
                surface.number > 1
                  ? surface.type.split(' ')[0] + 's' + surface.type.replace(surface.type.split(' ')[0], '')
                  : surface.type
              }}
            </div>
            <div
              class="col-5 value"
              v-html="surface.area"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  areas?: Array<any>
}>()

const show = ref(true)
const surfaces: any = reactive({})

onMounted(() => {
  props.areas?.forEach(function (area) {
    if (surfaces[area.type] == null) {
      surfaces[area.type] = area
      surfaces[area.type].area = (surfaces[area.type].area || '??') + ' m², '
    } else {
      surfaces[area.type].number += parseInt(area.number)
      surfaces[area.type].area += (area.area || '??') + ' m², '
      if (surfaces[area.type].number % 2 === 0) { surfaces[area.type].area += '<br>' }
    }
  })

  Object.keys(surfaces).forEach(function (key) {
    let area
    if (surfaces[key].area.substr(surfaces[key].area.length - 4) === '<br>') {
      area = surfaces[key].area.substring(0, surfaces[key].area.length - 6)
    } else { area = surfaces[key].area.substring(0, surfaces[key].area.length - 2) }

    area = area.replace('m² m²', 'm²')
    surfaces[key].area = area
  })
})
</script>

<style scoped>
#surfaces-container {
  margin-bottom: 30px;
}

.surface {
  border-bottom: 1px solid #CECFD6;
  font-size: 16px;
  margin-bottom: 15px;
  padding-bottom: 15px;
}

.row,
.label {
  padding-left: 0;
}

.surface .label {
  font-weight: bold;
}

.surface .value {
  text-align: right;
}
</style>
